var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuild(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13L11.6667 15.6667L17 10.3333M7.44632 3.26273C8.40303 3.18638 9.31128 2.81018 10.0418 2.18766C11.7464 0.734972 14.2536 0.734972 15.9582 2.18766C16.6887 2.81018 17.597 3.18638 18.5537 3.26273C20.7863 3.44089 22.5591 5.21374 22.7373 7.44632C22.8136 8.40303 23.1898 9.31128 23.8123 10.0418C25.265 11.7464 25.265 14.2536 23.8123 15.9582C23.1898 16.6887 22.8136 17.597 22.7373 18.5537C22.5591 20.7863 20.7863 22.5591 18.5537 22.7373C17.597 22.8136 16.6887 23.1898 15.9582 23.8123C14.2536 25.265 11.7464 25.265 10.0418 23.8123C9.31128 23.1898 8.40303 22.8136 7.44632 22.7373C5.21374 22.5591 3.44089 20.7863 3.26273 18.5537C3.18638 17.597 2.81018 16.6887 2.18766 15.9582C0.734972 14.2536 0.734972 11.7464 2.18766 10.0418C2.81018 9.31128 3.18638 8.40303 3.26273 7.44632C3.44089 5.21374 5.21374 3.44089 7.44632 3.26273Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuild);
export default __webpack_public_path__ + "static/media/build.c5d95ab92bcd98faa9fb48dc335f4839.svg";
export { ForwardRef as ReactComponent };